var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"Cover"}},[_c('img',{attrs:{"src":_vm.Pic[0].media_details.sizes.large.source_url,"alt":"Cover"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }